"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _InputError = _interopRequireDefault(require("./InputError"));

var _InputLabel = _interopRequireDefault(require("./InputLabel"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _constants = require("../constants");

var _lodash = _interopRequireDefault(require("lodash"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Container = _styledComponents["default"].div.withConfig({
  displayName: "selectAdvanced__Container",
  componentId: "sc-15wut72-0"
})(["margin-bottom:8px;.Select-control{border-radius:0;border:", ";border-bottom:", ";}"], function (props) {
  return props.inputStyle === "sm_minimal" ? "0" : "1px solid #ccc";
}, function (props) {
  return props.inputStyle === "sm_minimal" ? "1px solid #E6E6E6" : "1px solid #ccc";
});

var SafeProps = ["addLabelText", "aria-describedby", "aria-label", "aria-labelledby", "arrowRenderer", "autoBlur", "autofocus", "autosize", "backspaceRemoves", "backspaceToRemoveMessage", "className", "clearAllText", "clearRenderer", "clearValueText", "clearable", "deleteRemoves", "delimiter", "disabled", "escapeClearsValue", "filterOption", "filterOptions", "ignoreAccents", "ignoreCase", "inputProps", "inputRenderer", "instanceId", "isLoading", "joinValues", "labelKey", "matchPos", "matchProp", "menuBuffer", "menuContainerStyle", "menuRenderer", "menuStyle", "multi", "name", "noResultsText", "onBlur", "onBlurResetsInput", "onChange", "onClose", "onCloseResetsInput", "onFocus", "onInputChange", "onInputKeyDown", "onMenuScrollToBottom", "onOpen", "onValueClick", "openAfterFocus", "openOnFocus", "optionClassName", "optionComponent", "optionRenderer", "options", "pageSize", "placeholder", "required", "resetValue", "scrollMenuIntoView", "searchable", "simpleValue", "style", "tabIndex", "tabSelectsValue", "value", "valueComponent", "valueKey", "valueRenderer", "wrapperStyle"];

var SelectAdvancedInput = function SelectAdvancedInput(props) {
  var label = props.label,
      labelStyle = props.labelStyle,
      inputStyle = props.inputStyle,
      error = props.error,
      onChange = props.onChange,
      _onBlur = props.onBlur;
  return /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
    required: props.required,
    label: label,
    labelStyle: labelStyle,
    labelFor: props.name
  }, /*#__PURE__*/_react["default"].createElement(Container, {
    inputStyle: inputStyle,
    "data-test": "select-advanced"
  }, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], (0, _extends2["default"])({}, _lodash["default"].pick(props, SafeProps), {
    value: props.value,
    onChange: onChange,
    onBlur: function onBlur(e) {
      return _onBlur(_lodash["default"].merge(e, {
        target: {
          value: props.value
        }
      }));
    }
  }))), error.length !== 0 && /*#__PURE__*/_react["default"].createElement(_InputError["default"], null, error));
};

SelectAdvancedInput.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  inputStyle: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  options: _propTypes["default"].array.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  style: _propTypes["default"].object,
  error: _propTypes["default"].string,
  simpleValue: _propTypes["default"].bool,
  autoBlur: _propTypes["default"].bool
};
SelectAdvancedInput.defaultProps = {
  name: "select_dropdown",
  onChange: function onChange() {
    return false;
  },
  onBlur: function onBlur() {
    return true;
  },
  inputStyle: "achievement",
  labelStyle: "dark",
  simpleValue: true,
  autoBlur: false,
  required: false,
  style: {},
  error: ""
};
var _default = SelectAdvancedInput;
exports["default"] = _default;